export * from './Terms';
export { default } from './Terms';
